<template>
    <div class="sr-date-time-input">
        <div class="d-flex">
            <div class="mr-3">
                <DateInput ref="dateInput" v-model="date" v-bind="$attrs" :disabled="disabled" :time-zone="targetTimeZone" />
            </div>
            <div>
                <TimeInput v-model="time" :disabled="disabled" />
            </div>
        </div>
    </div>
</template>

<script>
import dateTimeConverter from './DateTimeConverter';
import DateInput from './DateInput';
import TimeInput from './TimeInput';

/**
 * Provides user-input with calendar to select date and clock to select time
 */
export default {
    name: 'SrDateTimeInput',
    components: {
        TimeInput,
        DateInput,
    },
    model: {
        prop: 'datetime',
    },
    props: {
        /**
         * @model
         * Format: ISO 8601, See https://www.w3.org/TR/NOTE-datetime
         * Example: 2021-01-19T16:38:29.111Z
         */
        datetime: {
            type: String,
            default: null,
        },
        /**
         * The target time zone adds/subtracts hours for given time zone
         * Example: Given timezone 'America/New_York' (UTC-05:00) would add 5 hours to user-input
         */
        targetTimeZone: {
            type: String,
            required: true,
        },
        defaultTime: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            date: null,
            time: this.defaultTime,
            lastEmittedDatetime: null,
        };
    },
    watch: {
        datetime: 'setDateAndTimeFromModel',
        date: 'emitDateTimeChange',
        time: 'emitDateTimeChange',
        targetTimeZone: 'emitDateTimeChange',
    },
    created() {
        this.setDateAndTimeFromModel();
    },
    methods: {
        validate() {
            return this.$refs.dateInput?.$refs.dateTextField?.validate();
        },
        setDateAndTimeFromModel() {
            this.validate();
            if (this.datetime === this.lastEmittedDatetime) {
                return;
            }
            if (!this.datetime) {
                this.time = this.defaultTime || '00:00:00';
                return;
            }
            const { date, time } = dateTimeConverter.utcToZoned(this.datetime, this.targetTimeZone);
            this.date = date;
            this.time = time;
        },
        emitDateTimeChange() {
            if (!this.date || !this.time) {
                return;
            }

            const dateFormatted = dateTimeConverter.zonedToUtc(this.date, this.time, this.targetTimeZone);

            this.lastEmittedDatetime = dateFormatted;
            this.$emit('input', dateFormatted);
        },
    },
};
</script>
